import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, onLearnMore }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="bg-white rounded-xl border border-border p-6 transition-all duration-300 hover:shadow-elevation group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Service Icon & Title */}
      <div className="flex items-start space-x-4 mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center transition-all duration-300 ${
          isHovered ? 'gradient-primary' : 'bg-primary/10'
        }`}>
          <Icon 
            name={service.icon} 
            size={24} 
            color={isHovered ? 'white' : 'var(--color-primary)'} 
          />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-foreground mb-2">
            {service.title}
          </h3>
          <p className="text-muted-foreground text-sm leading-relaxed">
            {service.description}
          </p>
        </div>
      </div>

      {/* Key Benefits */}
      <div className="mb-6">
        <h4 className="text-sm font-medium text-foreground mb-3">Key Benefits:</h4>
        <ul className="space-y-2">
          {service.benefits.map((benefit, index) => (
            <li key={index} className="flex items-start space-x-2 text-sm text-muted-foreground">
              <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Success Metrics - Shown on Hover */}
      <div className={`transition-all duration-300 overflow-hidden ${
        isHovered ? 'max-h-32 opacity-100 mb-4' : 'max-h-0 opacity-0'
      }`}>
        <div className="bg-primary/5 rounded-lg p-3">
          <h5 className="text-xs font-medium text-primary mb-2">Client Success Metrics</h5>
          <div className="grid grid-cols-2 gap-2">
            {service.metrics.map((metric, index) => (
              <div key={index} className="text-center">
                <div className="text-lg font-bold text-primary">{metric.value}</div>
                <div className="text-xs text-muted-foreground">{metric.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Learn More Button */}
      <Button
        variant="outline"
        fullWidth
        iconName="ArrowRight"
        iconPosition="right"
        onClick={() => onLearnMore(service)}
        className="group-hover:border-primary group-hover:text-primary"
      >
        Learn More
      </Button>
    </div>
  );
};

export default ServiceCard;